<script>
import { Menu } from 'element-ui'
export default {
  name: 'DwMenu',
  extends: Menu
}
</script>
